import { Injectable } from '@angular/core';
import { FarmingInfo } from '../../presentation-sheet/farming-info-table/models/farming-info';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, catchError, of, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FarmingService {
  private readonly endpointQuery = `${environment.api}/scheda-presentazione-query/allevamenti`;
  private readonly endpointCommand = `${environment.api}/scheda-presentazione-command/allevamenti`;

  constructor(private http: HttpClient) {}

  getById(schedaPresentazioneId: string): Observable<FarmingInfo[]> {
    return this.http
      .get<FarmingInfo[]>(
        this.endpointQuery + '/scheda/' + schedaPresentazioneId
      )
      .pipe(
        map((res) => {
          return res ? res : [];
        }),
        catchError((err) => of([]))
      );
  }

  add(formData: Partial<FarmingInfo>, schedaPresentazione: string) {
    let body: Partial<FarmingInfo> = {
      ...formData,
      schedaPresentazione,
    };
    return this.http.post(this.endpointCommand, body);
  }

  edit(updateExibits: FarmingInfo, id: string, schedaPresentazione: string) {
    let body: Partial<FarmingInfo> = {
      ...updateExibits,
      id,
      schedaPresentazione,
    };
    return this.http.put(this.endpointCommand + '/' + id, body);
  }

  delete(id: string) {
    return this.http.delete(this.endpointCommand + '/' + id);
  }
}
